export default __webpack_public_path__ + "static/media/logo.8389e281.png";